export default __webpack_public_path__ + "static/media/bounding-box.aa60b7a3.svg";